import axios from "axios";

export const check = (captchaToken) => axios.get(`/api/captcode/check`,{
    headers: {
      Captcha: captchaToken
    }
  });
